<template>
	<div class="login-section">
		<!-- Header -->
		<header>
			<div class="nymb-header">
				<img
					class="nymb-logo"
					width="180"
					src="../../assets/images/resized-logo.png"
					alt="NymbleUp"
					srcset=""
				/>
			</div>
		</header>
		<!-- Header -->
		<div
			class="LoginAndFreeTrial login-card"
			:class="isLocal || !isKFC || !isMCD || !isSBMY ? 'ns-mt-200' : ''"
		>
			<div class="login-logo">
				<img
					v-if="isKFC"
					class="login-logo-img"
					src="../../assets/images/kfc_logo.jpg"
					alt="kfc"
				/>
				<img
					v-else-if="isMCD"
					class="login-logo-img"
					src="../../assets/images/macd.png"
					alt="macd"
				/>
				<img
					v-else-if="isSBMY"
					class="login-logo-img"
					src="../../assets/images/logo/sb-my.png"
					alt="macd"
				/>
				<!-- <img class="login-logo-img" src="../../assets/images/kfc_logo.jpg" alt="kfc"> -->
			</div>
			<el-card v-loading="is_loading" class="box-card">
				<!-- Login -->
				<template v-if="is_login_action">
					<div class="LoginAndFreeTrial_login_section">
						<p class="LoginAndFreeTrial_text">
							Sign into your account with your Company Id and registered
							employee Id
						</p>
						<div class="LoginAndFreeTrial_input_section">
							<!-- <el-row :gutter="20">
                                <el-col :span="24">
                                    <div class="form-group1" :class="{ 'not-empty1': company_id.length }" >
                                        <input v-model="company_id" v-validate="is_login_action ? 'required' : ''" type="text" class="form-control1" name="Company Id"
                                            autocomplete="company_id" @keyup.enter="clickForLogin" />
                                        <label for="user" class="animated-label1">
                                            Company Id
                                        </label>
                                    </div>
                                    <span class="text-red-dark text-xs">
                                        {{ errors.first("Company Id") }}
                                    </span>
                                </el-col>
                            </el-row> -->

                            <!-- Base URL Selection -->
                            <div v-if="isLocalOrTestingEnv" class="flex items-center">
                                <el-select v-model="selected_base_url" placeholder="Select Client" class="ns-base-url-sel" @change="setBaseUrl">
                                    <el-option
                                    v-for="(item, index) in base_url_list"
                                    :key="index"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                                <!-- i icon -->
                                <el-tooltip class="item" effect="dark" content="This field is only for local & testing env." placement="top-start">
                                    <i class="el-icon-info ml-3"></i>
                                </el-tooltip>
                            </div>
                            <!-- Base URL Selection -->


							<el-row :gutter="20">
								<el-col :span="24">
									<div
										class="form-group1"
										:class="{ 'not-empty1': username.length }"
									>
										<input
											v-model="username"
											v-validate="is_login_action ? 'required' : ''"
											type="text"
											class="form-control1"
											name="Email"
											autocomplete="username"
											@keyup.enter="clickForLogin"
										/>
										<label for="user" class="animated-label1">
											Employee Id / Email
										</label>
									</div>
									<span class="text-red-dark text-xs">
										{{ errors.first("Email") }}
									</span>
								</el-col>
							</el-row>
							<el-row :gutter="20">
								<el-col :span="24">
									<div
										style=""
										class="form-group1"
										:class="{ 'not-empty1': password.length }"
									>
										<input
											v-model="password"
											v-validate="is_login_action ? 'required' : ''"
											:type="showPassword ? 'text' : 'password'"
											class="form-control1"
											name="Password"
											@keyup.enter="clickForLogin"
										/>
										<label for="user" class="animated-label1"> Password </label>
										<span v-if="showPassword">
											<img
												style="z-index: 9"
												src="../../assets/images/eye-slash.png"
												class="eye-image"
												@click="togglePasswordVisibility"
												alt="Toggle Password Visibility"
											/>
										</span>
										<span v-else-if="!showPassword">
											<img
												style="z-index: 9; height: 12px; width: auto"
												src="../../assets/images/show-password.png"
												class="eye-image"
												@click="togglePasswordVisibility"
												alt="Toggle Password Visibility"
											/>
										</span>
									</div>
									<span class="text-red-dark text-xs">
										{{ errors.first("Password") }}
									</span>
									<!-- <div class="mt-10">
                                        <el-checkbox v-model="show_password">Show Password</el-checkbox>
                                    </div> -->
                                </el-col>
                            </el-row>
                        </div>
                        <div class="mb-5">
                            <el-checkbox v-model="is_remember" class="ns-pass-rem">Remember me</el-checkbox>
                        </div>
                        <a class="LoginAndFreeTrial_forgot_password text-amplitude underline" @click="openForgotPassword()">
                            Reset Password
                        </a>
                        <span slot="footer" class="dialog-footer">
                            <div class="LoginAndFreeTrial_button">
                                <el-button id="ns-login" type="primary" class="submit-btn g-recaptcha" data-sitekey="6LdUirIoAAAAAKQTFwXP-0_HaJvvk6LkelC-3RTE" data-callback='onSubmit' @click="clickForLogin">
                                    LOG IN
                                </el-button>
                            </div>
                        </span>
                    </div>
                </template>

				<!-- Forgot password -->
				<template v-if="is_forgot_action && !is_login_action">
					<div class="LoginAndFreeTrial_input_section">
						<p
							class="LoginAndFreeTrial_text px-2 pt-5 pb-2"
							style="line-height: 1.5rem"
						>
							Enter the email address associated with your account and we'll
							send you a link to reset your password.
						</p>
						<!--
                        <el-row :gutter="20">
                            <el-col :span="24">
                                <div class="form-group1" :class="{ 'not-empty1': company_id_for_reset.length }" >
                                    <input v-model="company_id_for_reset" v-validate="is_forgot_action ? 'required' : ''" type="text" class="form-control1" name="Company Id"
                                        autocomplete="company_id_for_reset"/>
                                    <label for="user" class="animated-label1">
                                        Company Id
                                    </label>
                                </div>
                                <p>
                                    <span :v-show="errors.has(`Company Id`)" class=" text-red-dark text-xs">
                                        {{ errors.first(`Company Id`) }}
                                    </span>
                                </p>
                            </el-col>
                        </el-row>
                        -->
						<el-row>
							<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
								<div
									class="form-group1"
									:class="{ 'not-empty1': reset_email.length }"
								>
									<input
										v-model="reset_email"
										v-validate="is_forgot_action ? 'required|email' : ''"
										data-vv-validate-on="blur"
										type="email"
										class="form-control1"
										name="Reset Email"
										autocomplete="username"
									/>
									<label for="user" class="animated-label1">
										Email Address
									</label>
								</div>
								<span class="text-red-dark text-xs">
									{{ errors.first("Reset Email") }}
								</span>
							</el-col>
						</el-row>
					</div>
					<span>
						<div class="LoginAndFreeTrial_button mb-5">
							<el-button
								type="primary"
								class="cancel-btn"
								@click="cancelForForgot"
							>
								Back to Login
							</el-button>
							<el-button type="primary" @click="clickForForgot">
								Submit
							</el-button>
						</div>
					</span>
				</template>

				<!-- After forgot  password -->
				<template v-if="resetPassMailSent">
					<div class="my-8 block mx-auto my-0 text-center">
						<svg
							xmlns="http://www.w3.org/2000/svg"
							data-name="Layer 1"
							width="150"
							height="120"
							viewBox="0 0 570 511.67482"
							xmlns:xlink="http://www.w3.org/1999/xlink"
						>
							<path
								d="M879.99927,389.83741a.99678.99678,0,0,1-.5708-.1792L602.86963,197.05469a5.01548,5.01548,0,0,0-5.72852.00977L322.57434,389.65626a1.00019,1.00019,0,0,1-1.14868-1.6377l274.567-192.5918a7.02216,7.02216,0,0,1,8.02-.01318l276.55883,192.603a1.00019,1.00019,0,0,1-.57226,1.8208Z"
								transform="translate(-315 -194.16259)"
								fill="#3f3d56"
							/>
							<polygon
								points="23.264 202.502 285.276 8.319 549.276 216.319 298.776 364.819 162.776 333.819 23.264 202.502"
								fill="#e6e6e6"
							/>
							<path
								d="M489.25553,650.70367H359.81522a6.04737,6.04737,0,1,1,0-12.09473H489.25553a6.04737,6.04737,0,1,1,0,12.09473Z"
								transform="translate(-315 -194.16259)"
								fill="#e29d5a"
							/>
							<path
								d="M406.25553,624.70367H359.81522a6.04737,6.04737,0,1,1,0-12.09473h46.44031a6.04737,6.04737,0,1,1,0,12.09473Z"
								transform="translate(-315 -194.16259)"
								fill="#e29d5a"
							/>
							<path
								d="M603.96016,504.82207a7.56366,7.56366,0,0,1-2.86914-.562L439.5002,437.21123v-209.874a7.00817,7.00817,0,0,1,7-7h310a7.00818,7.00818,0,0,1,7,7v210.0205l-.30371.12989L606.91622,504.22734A7.61624,7.61624,0,0,1,603.96016,504.82207Z"
								transform="translate(-315 -194.16259)"
								fill="#fff"
							/>
							<path
								d="M603.96016,505.32158a8.07177,8.07177,0,0,1-3.05957-.59863L439.0002,437.54521v-210.208a7.50851,7.50851,0,0,1,7.5-7.5h310a7.50851,7.50851,0,0,1,7.5,7.5V437.68779l-156.8877,66.999A8.10957,8.10957,0,0,1,603.96016,505.32158Zm-162.96-69.1123,160.66309,66.66455a6.1182,6.1182,0,0,0,4.668-.02784l155.669-66.47851V227.33721a5.50653,5.50653,0,0,0-5.5-5.5h-310a5.50653,5.50653,0,0,0-5.5,5.5Z"
								transform="translate(-315 -194.16259)"
								fill="#3f3d56"
							/>
							<path
								d="M878,387.83741h-.2002L763,436.85743l-157.06982,67.07a5.06614,5.06614,0,0,1-3.88038.02L440,436.71741l-117.62012-48.8-.17968-.08H322a7.00778,7.00778,0,0,0-7,7v304a7.00779,7.00779,0,0,0,7,7H878a7.00779,7.00779,0,0,0,7-7v-304A7.00778,7.00778,0,0,0,878,387.83741Zm5,311a5.002,5.002,0,0,1-5,5H322a5.002,5.002,0,0,1-5-5v-304a5.01106,5.01106,0,0,1,4.81006-5L440,438.87739l161.28027,66.92a7.12081,7.12081,0,0,0,5.43994-.03L763,439.02741l115.2002-49.19a5.01621,5.01621,0,0,1,4.7998,5Z"
								transform="translate(-315 -194.16259)"
								fill="#3f3d56"
							/>
							<path
								d="M602.345,445.30958a27.49862,27.49862,0,0,1-16.5459-5.4961l-.2959-.22217-62.311-47.70752a27.68337,27.68337,0,1,1,33.67407-43.94921l40.36035,30.94775,95.37793-124.38672a27.68235,27.68235,0,0,1,38.81323-5.12353l-.593.80517.6084-.79346a27.71447,27.71447,0,0,1,5.12353,38.81348L624.36938,434.50586A27.69447,27.69447,0,0,1,602.345,445.30958Z"
								transform="translate(-315 -194.16259)"
								fill="#e29d5a"
							/>
						</svg>
						<h3 class="my-2">Email sent successfully</h3>
						<p class="my-2 mb-4">
							Please check your email, you will receive a link to create a new
							password via email
						</p>
                        <el-button
                            type="primary"
                            class="cancel-btn"
                            @click="backToLogin"
                        >
                            Back to Login
                        </el-button>
					</div>
				</template>
			</el-card>
		</div>
	</div>
</template>

<script>
import { serverAddr } from "../../networkConfig";
// import { LoginAndFreeTrialNC } from "../../../mixins/LoginAndFreeTrialNC";
import CommonService from "../../services/commonService";
import { mapState, mapActions } from "vuex";
import { base_url_list } from '../../utils/getBaseUrl';
export default {
    name: "Login",
    // mixins: [LoginAndFreeTrialNC],
    data() {
        return {
            dialogVisible: this.$store.state.show_login_and_freeTrial_model,
            passwordResetDialog: false,
            resetPassMailSent: false,
            isActive: false,
            submited: false,
            username: "",
            idDataUpdatedStatus: "",
            company_id: "",
            company_id_for_reset: "",
            password: "",
            is_forgot_action: false,
            is_login_action: true,
            reset_email: "",
            is_loading: false,
            show_password: false,
            showPassword: false,
            is_remember: false,
            selected_base_url: 'https://live.api.nymbleup.com/api/v1',
            base_url_list: base_url_list,
        };
    },
    computed: {
        ...mapState("CommonStore", ["companyData"]),
        ...mapState("networkConfig", ["baseUrlAddr"]),
        isKFC(){
            return window.location.href.includes('https://dil-kfc.nymbleup.com/');
        },
        isMCD(){
            return window.location.href.includes('https://hardcastleindia.nymbleup.com/') || window.location.href.includes('https://cprl.nymbleup.com/');
        },
        isSBMY(){
            return window.location.href.includes('https://mystarbucks.nymbleup.com');
        },
        isLocal(){
            return window.location.href.includes('http://localhost:');
        },
        isLocalOrTestingEnv(){
            // Check if the URL is localhost
            const url = window.location.href;
            return url.includes("localhost") || url.includes("web.app");
        }
    },
    created() {
        const r_email = localStorage.getItem('r_email');
		if(r_email){
			 this.username = r_email.toLocaleLowerCase();
			 this.is_remember = true;
		}
        // if(localStorage.getItem('x-access-token') &&  localStorage.getItem('user_id')) {
        //     let obj = {
        //         email: localStorage.getItem('user_email'),
        //         access_level: localStorage.getItem('user_access_level')
        //     }
        //     this.redirectAFterLogin(obj);
        // } else {
        //     this.is_loading = false;
        // }
    },
    mounted() {
        if (this.$route.name == "reset-password-by-email") {
            this.is_login_action = false;
            this.resetPassMailSent = false;
            this.is_forgot_action = true;
        } else if (this.$route.name == "login") {
            this.is_login_action = true;
            this.resetPassMailSent = false;
            this.is_forgot_action = false;
        }
        if(this.isLocalOrTestingEnv) {
            if(localStorage.getItem('BASE_URL')) {
                this.selected_base_url = localStorage.getItem('BASE_URL');
            } else {
                this.selected_base_url = 'https://live.api.nymbleup.com/api/v1';
                localStorage.setItem('BASE_URL', this.selected_base_url);
            }
        }
    },
    methods: {
        ...mapActions("CommonStore", ["getCompanyData", "getCompanyConfig"]),
        setBaseUrl(){
            //  Set BASE_URL to localStorage
            localStorage.setItem('BASE_URL', this.selected_base_url);
            setTimeout(() => {
                window.location.reload();
            }, 500);
        },
        togglePasswordVisibility() {
            this.showPassword = !this.showPassword;
        },
        openForgotPassword() {
            this.is_forgot_action = !this.is_forgot_action;
            this.is_login_action = !this.is_login_action;
            this.$router.push({ path: 'reset-password-by-email' }).catch(() => { });
            this.reset_email = '';
        },
        cancelForForgot() {
            this.is_forgot_action = !this.is_forgot_action;
            this.is_login_action = !this.is_login_action;
            this.$router.push({ path: 'login' }).catch(() => { });
        },
        backToLogin() {
            this.$router.push({ path: 'login' }).catch(() => { });
        },
        isEmail(emailAdress) {
            let regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

            if (emailAdress.match(regex))
                return true;
            else
                return false;
        },
        clickForForgot() {
            if (this.isEmail(this.reset_email)) {
                serverAddr
                    .post("/auth/users/reset_password/", {
                        email: this.reset_email
                    })
                    .then((res) => {
                        this.resetPassMailSent = true;
                        this.is_forgot_action = false;
                        this.is_login_action = false;
                        this.$notify.success({
                            title: "Success",
                            message: "Please check your mail for reset link."
                        });
                    }).catch(error => {
                        this.resetPassMailSent = false;
                        this.is_forgot_action = true;
                        this.is_login_action = false;
                        this.$notify.error({
                            title: "Error",
                            message: JSON.parse(error.response.data)[0]
                        });
                    });
            } else {
                console.log('Wrong email');
                this.$notify.error({
                    title: "Error",
                    message: 'Please enter valid email',
                });
            }
        },
        validateBaseUrlByCompanyCode(action) {
            let baseUrl = '';
            let companyCode = action == 'reset' ? this.company_id_for_reset : this.company_id;
            this.is_loading = true;
            if (companyCode) {
                serverAddr({
                    baseURL: `${this.baseUrlAddr}`
                });
                // return this.baseUrlAddr
                return serverAddr
                    .post("/prelogin/get/base_url_using_company_code/", {
                        company: companyCode,
                    })
                    .then((res) => {
                        baseUrl = JSON.parse(res.data);
                        if (!baseUrl.base_url) {
                            this.$notify.error({
                                title: "Error",
                                message: "Please enter valid company Id",
                                type: "Error"
                            });
                        } else {
                            localStorage.setItem('BASE_URL', baseUrl.base_url);
                        }
                    }).catch(error => {
                        this.is_loading = false;
                        this.$notify.error({
                            title: "Error",
                            message: "Please enter valid company Id",
                            type: "Error"
                        });
                    });
            }
        },
        async clickForLogin() {
            // await this.validateBaseUrlByCompanyCode('login');
            this.$validator.validateAll().then(result => {
                if (result) {
                    this.is_loading = true;
                    serverAddr
                        .post("/users/login/", {
                            email: this.username.toLocaleLowerCase(),
                            password: this.password
                        })
                        .then((res) => {
                            this.postLoginNC(res, {r_email: this.username.toLocaleLowerCase()});
                        })
                        .catch(error => {
                            this.is_loading = false;
                            this.$notify.error({
                                title: "Error",
                                message: "Your username or password is incorrect. Please try again or reset your password.",
                                type: "Error"
                            });
                        });
                }
            });
        },
        postLoginNC(response, rememberData) {
            const x_access_token = JSON.parse(response.data).access;
            const x_refresh_token = JSON.parse(response.data).refresh;
            // console.log("access", x_access_token, "refresh", x_refresh_token);
            if (response.status == 200) {
                this.is_loading = false;
                window.localStorage.setItem(
                    "x-access-token",
                    JSON.stringify(x_access_token)
                );
                window.localStorage.setItem(
                    "x-refresh-token",
                    JSON.stringify(x_refresh_token)
                );
                this.getCompanyData();
                this.getCompanyConfig();
                this.isDataUpdated();
                this.getLoginUserDetails();
                // Set login expiration time
                let currentTime = new Date();
                localStorage.setItem('session_expiration_time', currentTime);
            }
            // window.location.reload();
            this.$notify.success({
                title: "Success",
                message: "Success",
                type: "success"
            });

            // Clear local storage store info
            if (localStorage.getItem('store_id')) {
                localStorage.setItem('store_id', '');
            }

            if (this.is_remember) {
				localStorage.setItem('r_email', rememberData.r_email);
			} else if(localStorage.getItem('r_email')){
				localStorage.removeItem('r_email');
			}
        },
        redirectAFterLogin(user_info) {
            console.log(user_info,'user_info')
            let company_id = localStorage.getItem('company_id')
            if (!this.idDataUpdatedStatus) {
                if (
                    user_info.email.toLowerCase().indexOf('@theobroma.in') !== -1 || 
                    user_info.email == 'tushar.shinde@wellnessforever.in' || 
                    user_info.email == 'gokuldas.gawade@wellnessforever.in' || 
                    user_info.email == 'safiahmad.khan@wellnessforever.in' || 
                    user_info.email == 'ratnesh.maurya@wellnessforever.in' || 
                    user_info.email == 'amar.soni@wellnessforever.in' || 
                    this.companyData.name == 'Easy Aspataal' || 
                    user_info.email == 'ajitagawade1994@gmail.com' || 
                    user_info.email == 'prateek@easyaspataal.com' || 
                    user_info.email == 'theobroma@nymbleup.com'
                ) {
                    if(user_info.access_level == 'outlet') {
                        this.$router.push({ name: "Tickets" }).catch(() => { });
                    } else {
                        // this.$router.push({ name: "Tasks" }).catch(()=>{});
                        this.$router.push({ name: "TicketsDashboard" }).catch(() => { });
                    }
                } else if(company_id === '8b1e19d9-2d9b-433e-80c2-5de46e2c9410'){
                    this.$router.push({ name: "Tasks" }).catch(() => { });
                }
            
                else {
                    if (user_info.access_level == "vendor") {
                        this.$router.push({ name: "SentOrder" }).catch(() => { });
                    } else if (user_info.access_level == "employee") {
                        this.$router.push({ name: "SchedulePlanner" }).catch(() => { });
                    } else if (user_info.access_level == 'outlet') {
                        this.$router.push({ name: "SchedulePlanner" }).catch(() => { });
                    } else {
                        this.$router.push({ name: "SchedulePlanner" }).catch(() => { });
                    }
                }
            } else {
                this.$router.push("/admin/sales-dd/location").catch(() => { });
            }
            if(user_info.id === 'cf72c191-7394-4415-ba5e-aebbbf9fd924'){
                    this.$router.push({ name: "ChildPages" }).catch(() => { });
                }
        },
        isDataUpdated() {
            CommonService.isDataUpdated().then(response => {
                // console.log("dataupdated", JSON.parse(response.data).status);
                this.idDataUpdatedStatus = JSON.parse(response.data).status;
            });
        },
        getLoginUserDetails() {
            serverAddr
                .get("/users/self/", {})
                .then(response => {
                    this.getLoginInfo(response);
                })
                .catch(error => {
                    console.error(error.response);
                    if (error.response && error.response.data) {
                        this.$notify.error({
                            title: "fail",
                            message: JSON.parse(error.response.data).name[0]
                        });
                    }
                });
        },
        getLoginInfo(response) {
            try {
                let user_info = JSON.parse(response.data);
                this.$store.commit("getUserDetails", user_info);
                localStorage.setItem("user_id", user_info.id); //stored user name for show sub dropdown in side bar
                localStorage.setItem("user_email", user_info.email); //stored user name for show sub dropdown in side bar
                localStorage.setItem("full_name", user_info.full_name); //stored user name for show sub dropdown in side bar
                localStorage.setItem("user_access_level", user_info.access_level); //stored user name for show sub dropdown in side bar

				localStorage.setItem("access_region", user_info.access_region[0]); //stored user name for show sub dropdown in side bar
				localStorage.setItem("access_subregion", user_info.access_subregion[0]); //stored user name for show sub dropdown in side bar
				localStorage.setItem("access_outlet", user_info.access_outlet); //stored user name for show sub dropdown in side bar
				this.redirectAFterLogin(user_info);
			} catch (error) {
				console.error(error);
			}
		},
	},
};
</script>

<style lang="scss" scoped>
@import "../loginAndFreeTrial/LoginAndFreeTrial.scss";
@import "../../assets/css/variable.scss";

.login-card {
	max-width: 600px;
	margin: 0 auto;
	margin-top: 150px;
}

.login-logo-img {
	width: 125px;
	display: block;
	margin: 0 auto;
}
.ns-mt-200 {
	margin-top: 200px !important;
}
.login-logo {
	display: block;
	margin: 0 auto;
	margin-bottom: 15px;
}

.login-section {
	height: 95vh;
}
</style>

<style>
.LoginAndFreeTrial .el-dialog {
	height: auto;
	max-height: 90%;
	max-width: 650px;
	width: 680px;
	margin-top: 0 !important;
}

.nymb-header {
	margin-left: 5px;
	margin-top: 5px;
}

/* close button css */
.el-dialog__headerbtn:focus .el-dialog__close,
.el-dialog__headerbtn:hover .el-dialog__close:hover {
	color: #3d3e3e;
}

.LoginAndFreeTrial .el-dialog__body {
	padding: 0 0 30px 0;
}

.LoginAndFreeTrial .el-dialog__header {
	@apply p-0;
}

.LoginAndFreeTrial .LoginAndFreeTrial_button {
	text-align: right !important;
}

.LoginAndFreeTrial .cancel-btn {
	background-color: #fff !important;
	color: #e29d5a !important;
}

.LoginAndFreeTrial .cancel-btn:hover {
	background-color: #fff !important;
	color: #e29d5a !important;
}

.LoginAndFreeTrial .el-button--primary {
	background-color: #e29d5a;
	padding: 13px 12px 11px;
	border-radius: 2px;
	font-size: 15px;
	cursor: pointer;
	letter-spacing: 0.02em;
	transition: all 0.2s ease;
	color: #fff;
	border: none;
}

.LoginAndFreeTrial .el-button--primary:hover {
	opacity: 0.9;
}

@media screen and (max-width: 700px) {
	.LoginAndFreeTrial .el-dialog {
		width: 90%;
	}
}

@media screen and (max-width: 576px) {
	.LoginAndFreeTrial .LoginAndFreeTrial_button {
		margin-top: 20px;
		text-align: center !important;
	}
}

.mt-10 {
	margin-top: 10px;
}

.eye-image {
	position: absolute;
	top: 68%;
	right: 10px;
	/* Adjust as per your requirements */
	transform: translateY(-50%);
	cursor: pointer;
	width: auto;
	/* Adjust the width and height of the image */
	height: 15px;
}
.ns-pass-rem .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #e29d5a !important;
    border-color: #e29d5a !important;
}
.ns-pass-rem .el-checkbox__inner:hover {
    border-color: #e29d5a	 !important;
}
.ns-base-url-sel{
     width: 100%;
     border: #e29d5a dashed 1px;
     padding: 5px;
     text-transform: uppercase !important;
     border-radius: 8px;
}
</style>
